export default __webpack_public_path__ + "static/media/hope_at _last_mobile.c8d22095.webp";